import { render } from "./ClipboardList.vue?vue&type=template&id=4c15e622"
import script from "./ClipboardList.vue?vue&type=script&lang=js"
export * from "./ClipboardList.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "4c15e622"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4c15e622', script)) {
    api.reload('4c15e622', script)
  }
  
  module.hot.accept("./ClipboardList.vue?vue&type=template&id=4c15e622", () => {
    api.rerender('4c15e622', render)
  })

}

script.__file = "src/icons/components/filled/ClipboardList.vue"

export default script